import type { ConstructionTypeType } from '@/types/ui/inspection/constructionTypeTypes'
import { CONSTRUCTION_TYPE } from '@/constants/accessor/api/emergencyInspectionResult/assessmentInfo/constructionType'

const WOOD = {
  roofTile: '➀',
  windowFrame: '➁',
  exteriorWetMaterial: '➂',
  exteriorDryMaterial: '➃',
  signboard: '➄',
  outdoorStairs: '➅',
  otherItem: '➆'
}

const STEEL = {
  roofMaterial: '➀',
  windowFrame: '➁',
  exteriorWetMaterial: '➂',
  exteriorDryMaterial: '➃',
  signboard: '➄',
  outdoorStairs: '➅',
  otherItem: '➆'
}

const RC = {
  windowFrame: '➀',
  exteriorWetMaterial: '➁',
  exteriorDryMaterial: '➂',
  signboard: '➃',
  outdoorStairs: '➄',
  otherItem: '➅'
}

const number = {
  [CONSTRUCTION_TYPE.WOOD]: WOOD,
  [CONSTRUCTION_TYPE.STEEL]: STEEL,
  [CONSTRUCTION_TYPE.RC]: RC
}

/**
 * 指定された建物構造タイプに対応するカードのナンバーを返却する
 *
 * @param selectedConstructionType 選択された構造タイプ
 * @returns 該当するカードのナンバー
 */
export const getFallingCardNumbers = (selectedConstructionType: ConstructionTypeType) => {
  const numbers = number[selectedConstructionType]

  if (!numbers) {
    console.error(`Invalid construction type: ${selectedConstructionType}`)
    return null
  }

  return numbers
}
